import React from 'react';
import {useCloseOnEnterSpace} from '../../hooks/input/useCloseOnEnterSpace';
import './PolicyCardOverlay.css';
import PageButton from "../elements/PageButton/PageButton";
import {getPolicyImagePath} from "../../utils/policy/getPolicyImagePath";
import {calcPolicyPrice} from "../../utils/policy/calcPolicyPrice";
import {CoinsStat} from "../PlayerStat/stats/CoinsStat";
import {POLICIES} from "../../constants/policies";
import PolicyDespotismDescription from "./descriptions/PolicyDespotismDescription/PolicyDespotismDescription";
import PolicyIndustrialismDescription
  from "./descriptions/PolicyIndustrialismDescription/PolicyIndustrialismDescription";
import PolicyMilitarismDescription from "./descriptions/PolicyMilitarismDescription/PolicyMilitarismDescription";
import PolicyPatriotismDescription from "./descriptions/PolicyPatriotismDescription/PolicyPatriotismDescription";
import PolicyOligarchyDescription from "./descriptions/PolicyOligarchyDescription/PolicyOligarchyDescription";
import PolicyHegemonismDescription from "./descriptions/PolicyHegemonismDescription/PolicyHegemonismDescription";
import PolicyBarbarismDescription from "./descriptions/PolicyBarbarismDescription/PolicyBarbarismDescription";
import PolicyTotalitarianismDescription
  from "./descriptions/PolicyTotalitarianismDescription/PolicyTotalitarianismDescription";
import PolicyServarianismDescription from "./descriptions/PolicyServarianismDescription/PolicyServarianismDescription";
import PolicyFortificationismDescription
  from "./descriptions/PolicyFortificationismDescription/PolicyFortificationismDescription";
import PolicyEcoanarchismDescription from "./descriptions/PolicyEcoanarchismDescription/PolicyEcoanarchismDescription";
import PolicyTheocracyDescription from "./descriptions/PolicyTheocracyDescription/PolicyTheocracyDescription";
import PolicyFanaticismDescription from "./descriptions/PolicyFanaticismDescription/PolicyFanaticismDescription";
import PolicyAgrarianismDescription from "./descriptions/PolicyAgrarianismDescription/PolicyAgrarianismDescription";
import PolicyIsolationismDescription from "./descriptions/PolicyIsolationismDescription/PolicyIsolationismDescription";
import {MENU_SOUND_MANAGER} from "../../scenes/MenuSoundManager";
import {getCityCaptureFadeProps} from "../gameUi/cityCapturePanelsFade";

const PAGE_ID = 'PolicyCardOverlay';

const PolicyCardOverlay = (
  {
    selectedPolicy,
    selectedPolicyIndex,
    player,
    handlePurchase,
    isMarketPolicySelected,
    onClose,
    onHide
  }
) => {
  const handleHideClick = () => {
    MENU_SOUND_MANAGER.playSideMenuClick();
    if (onHide) {
      onHide();
    } else {
      onClose();
    }
  };

  useCloseOnEnterSpace(handleHideClick);

  if (!selectedPolicy) {
    return null;
  }

  let description = selectedPolicy.description;
  switch (selectedPolicy.id) {
    case POLICIES.DESPOTISM:
      description = <PolicyDespotismDescription
        policy={selectedPolicy}
      />
      break;
    case POLICIES.INDUSTRIALISM:
      description = <PolicyIndustrialismDescription/>
      break;
    case POLICIES.MILITARISM:
      description = <PolicyMilitarismDescription/>
      break;
    case POLICIES.PATRIOTISM:
      description = <PolicyPatriotismDescription/>
      break;
    case POLICIES.OLIGARCHY:
      description = <PolicyOligarchyDescription/>
      break;
    case POLICIES.HEGEMONISM:
      description = <PolicyHegemonismDescription/>
      break;
    case POLICIES.BARBARISM:
      description = <PolicyBarbarismDescription/>
      break;
    case POLICIES.TOTALITARIANISM:
      description = <PolicyTotalitarianismDescription/>
      break;
    case POLICIES.SERVARIANISM:
      description = <PolicyServarianismDescription/>
      break;
    case POLICIES.FORTIFICATIONISM:
      description = <PolicyFortificationismDescription/>
      break;
    case POLICIES.ECOANARCHISM:
      description = <PolicyEcoanarchismDescription/>
      break;
    case POLICIES.THEOCRACY:
      description = <PolicyTheocracyDescription/>
      break;
    case POLICIES.FANATICISM:
      description = <PolicyFanaticismDescription/>
      break;
    case POLICIES.AGRARIANISM:
      description = <PolicyAgrarianismDescription/>
      break;
    case POLICIES.ISOLATIONISM:
      description = <PolicyIsolationismDescription/>
      break;
    default:
  }

  return (
    <div className="faction-card-overlay" onClick={onClose} {...getCityCaptureFadeProps(true)}>
      <div className="faction-card-overlay-content" onClick={(e) => e.stopPropagation()}>
        <div className="policy-card-overlay_policy-card standard-background">
          <img
            className="policy-card-overlay_policy-img"
            src={getPolicyImagePath(selectedPolicy.id)}
            alt={selectedPolicy.name}
          />

          <h3
            className="policy-card-overlay_policy-name"
          >
            {selectedPolicy.name}
          </h3>

          <div
            className={`policy-card-overlay_policy-description ${selectedPolicy.id}`}
          >
            {description}
          </div>
        </div>


        <div className="main-menu-buttons">
          <div className="policy-card-overlay_buttons-container">
            {isMarketPolicySelected && (<PageButton
              className={'policy-card-overlay_buy-button'}
              data-tutorial-select={'policy_buy_button'}
              onClick={handlePurchase}
              noSound={true}
              pageId={PAGE_ID}
              buttonId="buy"
            >
              <span>Купить</span>
              <CoinsStat
                text={calcPolicyPrice(selectedPolicyIndex, player)}
                noShrinkOnMobile={true}
              />
            </PageButton>)}
            <PageButton
              onClick={handleHideClick}
              noSound
              pageId={PAGE_ID}
              buttonId="hide"
              data-tutorial-select={'policy_card_close'}
            >Скрыть</PageButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolicyCardOverlay;
